import {RouteProps} from 'react-router-dom';
import NotFound from '@pages/NotFound';
import {Route} from './enums/route';
import CallCenter from "@pages/CallCenter";
import PhoneSimulator from "@pages/PhoneSimulator";

const routesPaths: Record<Route, string> = {
  [Route.Home]: '/',
  [Route.CallCenter]: '/call-center',
  [Route.PhoneSim]: '/phone-sim',
  [Route.NotFound]: '*',
};

const routesForRedirect = {
  home: '/',
  callCenter: '/call-center',
  phoneSim: '/phone-sim',
  default: '/',
};

type RouterConfigType = Record<
  Route,
  RouteProps & {
  sideBar?: () => JSX.Element;
  navBar?: () => JSX.Element;
}
>;

const getRoutesConfig = (): RouterConfigType => {
  const baseRouter = {
    [Route.Home]: {
      path: routesPaths[Route.Home],
      element: <CallCenter/>,
    },
    [Route.CallCenter]: {
      path: routesPaths[Route.CallCenter],
      element: <CallCenter/>,
    },
    [Route.PhoneSim]: {
      path: routesPaths[Route.PhoneSim],
      element: <PhoneSimulator/>,
    },
    [Route.NotFound]: {
      path: routesPaths[Route.NotFound],
      element: <NotFound/>,
    },
  };

  return baseRouter as RouterConfigType;
};

export {getRoutesConfig, Route, routesForRedirect, routesPaths};
